import { IApplicationState } from "./IApplicationState";

const onlyNumbers = (held: any): number[] => Array.isArray(held) ? held.filter(x => typeof x === 'number') : [];

/**
 * What was kept in the browser (see saveState) by a version of the Portal that wrote permissions as names holds
 * names, which are not permissions now: only the numbers are kept.  What the user holds is read from the API when the
 * page opens, so nothing is lost, but a page that is shown before that must not be given names to work with.
 * @param userdata The user data that was kept
 */
export const withNumberedPermissions = (userdata: any) => {
    if (!userdata || !userdata.user) {
        return userdata;
    }

    const byServiceCenter: { [serviceCenter: string]: number[] } = {};
    const kept = userdata.user.permissionsByServiceCenter || {};
    Object.keys(kept).forEach(serviceCenter => byServiceCenter[serviceCenter] = onlyNumbers(kept[serviceCenter]));

    return {
        ...userdata,
        user: {
            ...userdata.user,
            permissions: onlyNumbers(userdata.user.permissions),
            permissionsByServiceCenter: byServiceCenter
        }
    };
};

export const loadState = () => {
    try {
        const serializedState = localStorage.getItem('state.cacheddata');
        if (serializedState === null) {
            return undefined;
        }

        return JSON.parse(serializedState);
    }
    catch (err) {
        return undefined;
    }
}

export const saveState = (state: IApplicationState) => {
    try {

        const partialState = {
            userdata: state.userdata
        };

        const serializedPartial = JSON.stringify(partialState);

        localStorage.setItem('state.cacheddata', serializedPartial);
    }
    catch (err) {
        console.error('An error occurred trying to save state', err);
    }
}
